import { Briefcase, CreditCard, Users, TrendingUp, CheckCircle } from 'lucide-react';

const CORPORATE_IMAGE = 'https://images.unsplash.com/photo-1574202141112-c3a90e1a3ce2';

const benefits = [
  { icon: CreditCard, title: 'Faturamento em 30 Dias', description: 'Condições de pagamento flexíveis adaptadas ao seu fluxo de caixa' },
  { icon: TrendingUp, title: 'Descontos Corporativos', description: 'Tarifas especiais para grupos e viagens recorrentes' },
  { icon: Users, title: 'Gestor Dedicado', description: 'Profissional exclusivo para gerenciar suas viagens' },
  { icon: Briefcase, title: 'Pacotes Customizados', description: 'Viagens planejadas conforme necessidades da sua empresa' },
];

export default function Corporate() {
  return (
    <section id="corporate" className="section-divider text-white relative overflow-hidden" style={{ backgroundImage: `url(${CORPORATE_IMAGE})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
      <div className="absolute inset-0" style={{ background: 'linear-gradient(90deg, rgba(30,90,150,0.9), rgba(30,60,120,0.9), rgba(30,90,150,0.9))' }}></div>

      <div className="relative z-10">
        <div className="container">
          <div className="flex flex-col items-center text-center space-y-12">
            <div className="max-w-2xl space-y-6 fade-in-down">
              <div className="inline-block px-4 py-2 bg-white/20 border border-white/40 rounded-full">
                <p className="text-white font-bold text-sm flex items-center justify-center gap-2">
                  <Briefcase size={16} />
                  VIAGENS CORPORATIVAS
                </p>
              </div>
              <h2 className="text-4xl md:text-5xl font-bold text-white leading-tight">Viagens de Negócios Sem Complicações</h2>
              <p className="text-lg text-white/90 font-medium">
                Oferecemos soluções completas para viagens corporativas com faturamento flexível, descontos especiais e gestão personalizada. Deixe a logística conosco enquanto você foca no seu negócio.
              </p>
              <a href="https://wa.me/5548991904829?text=Olá! Gostaria de solicitar uma proposta corporativa para viagens de negócios." target="_blank" rel="noopener noreferrer" className="btn-secondary inline-flex items-center gap-2 mx-auto no-underline">
                Solicitar Proposta Corporativa
                <CheckCircle size={20} />
              </a>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 w-full">
              {benefits.map((benefit, index) => {
                const Icon = benefit.icon;
                return (
                  <div key={index} className="p-6 bg-white/10 backdrop-blur-sm border border-white/20 rounded-xl hover:border-accent hover:bg-white/15 transition-all duration-300 fade-in-up flex flex-col items-center text-center" style={{ animationDelay: `${index * 100}ms` }}>
                    <div className="mb-4 p-3 bg-accent/20 rounded-lg w-fit">
                      <Icon size={28} className="text-accent" />
                    </div>
                    <h3 className="font-bold text-lg mb-2 text-white">{benefit.title}</h3>
                    <p className="text-white/80 text-sm">{benefit.description}</p>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
